<div class="container">
    @for (dice of text; track dice.letter) {
        <app-dice [dice]="dice"></app-dice>
    }
</div>